
document.querySelector('.shinseikigoods')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods2')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul2').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods3')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul3').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods4')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul4').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods5')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul5').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods6')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul6').classList.toggle('is-opendinos');
  }); 

document.querySelector('.shinseikigoods7')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul7').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods8')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul8').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods9')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul9').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods10')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul10').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods11')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul11').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods12')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul12').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods13')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul13').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods14')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul14').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods15')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul15').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods16')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul16').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods17')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul17').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods18')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul18').classList.toggle('is-opendinos');
  });

 document.querySelector('.shinseikigoods19')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul19').classList.toggle('is-opendinos');
  });

  document.querySelector('.shinseikigoods20')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiul20').classList.toggle('is-opendinos');
  });

  document.querySelector('.shinseikigoodsta')
  .addEventListener('click', function() {
    document.querySelector('.shinseikiulta').classList.toggle('is-opendinos');
  });
